export default __webpack_public_path__ + "static/media/briefcase-alt.6471c7f8.svg";